import React, { useEffect } from "react";
import { useLocation, useMatch, useParams } from "react-router-dom";
import CombineMenu from "../components/common/combineMenu/CombineMenu";
import FixedFooter from "../components/common/footer/FixedFooter";
import Page from "../components/community/Page/Page";
import PageHeader from "../components/community/Page/pageHeader/PageHeader";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import "../language/i18n";
import {
  visibleState,
  popState,
  writingTypeState,
  isMobileMatcheState,
  isDetailState,
  connectSiteState,
  langCodeState
} from "../atoms/atom";
import DetailPage from "../components/community/DetailPage/DetailPage";
import PopPageWrite from "../components/community/Poppagewrite/PopPageWrite";
import PopPageComments from "../components/community/PopPageComments/PopPageComments";
import { useMediaQuery } from "react-responsive";
import Footer from "../components/common/footer/Footer";
import LevelInformation from "../components/common/footer/LevelInformation/LevelInformation";
import { Helmet } from "react-helmet-async";

export interface IPageHeaderShowProps {
  len?: string;
}

function Main() {
  const [visible, setVisible] = useRecoilState(visibleState);
  const params = useParams();
  const detailMatch = useMatch(`page/${params.service_code}/${params.title}/${params.idx}`);
  const setMatch = useSetRecoilState(isMobileMatcheState);
  const setIsDetail = useSetRecoilState(isDetailState);
  const connectSite = useRecoilValue(connectSiteState);
  const lang = useRecoilValue(langCodeState);

  const isMobile = useMediaQuery({
    query: "screen and (max-width: 768px)"
  });
  useEffect(() => {
    setMatch(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (detailMatch === null) {
      setIsDetail(false);
    } else {
      setIsDetail(true);
    }
  }, [detailMatch]);

  useEffect(() => {
    const handleScroll = () => {
      try {
        if (window.scrollY > 0) {
          setVisible(false);
        } else {
          setVisible(true);
        }
      } catch (error) {
        // console.log(error);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  const len = visible ? "" : "short";

  const [popOpen, setPopOpen] = useRecoilState(popState);
  const closeModal = () => setPopOpen(false);
  const writingType = useRecoilValue(writingTypeState);
  return (
    <div id="community">
      <Helmet htmlAttributes={{ lang: `${lang}` }} />
      {connectSite === "vfun" && <CombineMenu />}
      <div id="content" className="clearfix">
        <PageHeader />
        <Page len={len} />
      </div>
      {detailMatch && <DetailPage />}
      {/* 글쓰기와 댓글 쓰기를 분리한다면 open, close만 필요 */}
      {writingType === "reply" ? (
        <PopPageComments open={popOpen} close={closeModal} />
      ) : (
        <PopPageWrite open={popOpen} close={closeModal} />
      )}
      <LevelInformation />
      <FixedFooter />
    </div>
  );
}

export default Main;
